export default {"src":"/_next/static/media/delete-file-btn.884c42ea.svg","height":28,"width":28};